import { Box, Modal, ModalClose, ModalDialog, Typography, Divider, Button } from "@mui/joy";
import React from "react";
import ClockIcon from "../custom/ClockIcon";
import { useQuery } from "@tanstack/react-query";
import { get_user_account } from "../../services/UserAccount";


function map_plan_value(specialty) {
    switch(specialty) {
        case('Hygienist'): {
            return '$49 USD or $69 CAD'
        }
        default: {
            return '$79 USD or $109 CAD'
        }
    }
}

function UpgradeModal({ open, setClose }) {
    const { data: user, isLoading: loadingUser } = useQuery({
        queryKey: ['user'],
        staleTime: 5 * 1000,
        queryFn: get_user_account,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    })

    const handleUpgrade = () => {
        window.open("https://umvgsq4b6bv.typeform.com/to/v23gIfFX", '_blank', 'noopener,noreferrer');
    };

    const handleBookSession = () => {
        window.open("https://calendly.com/d/cv2y-vng-7pq/abelscribe-demo", '_blank', 'noopener,noreferrer');
    }

    return <Modal open={open} onClose={setClose}>
        <ModalDialog>
            <ModalClose variant="plain" sx={{ m: 1, width: "fit-content" }} />
            {user && <Box sx={{ alignItems: "center", display: "flex", flexDirection: "column", my: 2, mx: 1, gap: 1 }}>
                <ClockIcon/>
                <Typography level="title-lg"> Upgrade </Typography>
                <Typography level="body-sm"> You are currently on a free trial of ABEL Scribe</Typography>
                <Box sx={{ backgroundColor: "var(--light-gray)", width: "100%", m: 1, borderRadius: "16px", p: 2, justifyItems: "center"}}>
                    <Typography level="body-sm"> Upgrade to continue using Abel Scribe</Typography>
                    <Typography level="body-sm"> and gain <Typography level="body-sm" textColor="var(--main-blue)">unlimited notes per User</Typography>.</Typography>
                </Box>
                <Divider sx={{ my: 1 }}/>
                <Box sx={{ width: "100%", m: 1, borderRadius: "16px", p: 2, justifyItems: "center", border: "1px solid var(--light-gray)"}}>
                    <Typography level="body-sm"> <Typography level="title-md"> {map_plan_value(user.specialty)}</Typography> /month</Typography>
                    <Typography level="body-sm"> {user.specialty} License</Typography>
                </Box>
                <Typography level="body-xs"> Billed by ABEL monthly. </Typography>
                <Button onClick={handleUpgrade}>
                    Notify Administrator
                </Button>
                <Box sx={{ backgroundColor: "var(--light-blue-button-hover)", width: "100%", m: 1, borderRadius: "16px", p: 2, justifyItems: "center"}}>
                    <Typography level="body-sm"> If you have any questions, book a time with our team:</Typography>
                    <Button variant="plain" sx={{ backgroundColor: "white", display: "flex", my: 1 }} onClick={handleBookSession}>
                        Book a Session
                    </Button>
                </Box>
            </Box>}
        </ModalDialog>
    </Modal>
}

export default UpgradeModal